module.exports = __webpack_public_path__ + "static/img/1031_small.a72f24c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1031_small.png
// module id = qPNl
// module chunks = 1